<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
    class="o-edition-section-content"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    key="sectionContent"
    class="o-edition-section-content"
  >
    <MoleculeEditionSectionContentSubMenu
      :go-back-text="goBackText"
      :section="section"
      :subject="subject"
      :subedition="subedition"
    />
    <!--<transition name="a-transtion-slide">-->
    <MoleculeEditionSectionContentSubject
      v-if="$route.meta.isEdition === 'asset' || $route.meta.isEdition === 'product' || $route.meta.isEdition === 'map' "
      :is="molecule"
      :element="element"
      :element-categorias="elementCategorias"
    />
    <MoleculeEditionSectionContentSubject
      v-else
      :is="molecule"
    />
    <!--</transition>-->
    <MoleculeEditionSectionContentFooter/>
  </div>
</template>

<script>
export default {
  name: 'OrganismEditionSectionContent',

  props: {
    element: Object,
    elementCategorias: Array,
    goBackText: String,
    molecule: Function,
    section: String,
    showLoadingState: Number,
    subject: String,
    subedition: String
  },

  components: {
    MoleculeEditionSectionContentSubMenu: () => import('@/components/molecules/MoleculeEditionSectionContentSubMenu'),
    MoleculeEditionSectionContentFooter: () => import('@/components/molecules/MoleculeEditionSectionContentFooter')
  }
}
</script>
